import { render, staticRenderFns } from "./ExhibitionsBannerComingSoonEn.vue?vue&type=template&id=112acba0&"
import script from "./ExhibitionsBannerComingSoonEn.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsBannerComingSoonEn.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionsBannerComingSoonEn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports